module.exports = __webpack_public_path__ + "img/target-1.a04a9426.png";